import type { TBucketKey } from '@crm/entities/deals-board';

export const bucketStylesByKey: Record<TBucketKey, string> = {
    lost: 'text-smtr-main-tertiary-100',
    'in_work_or_finished': 'text-smtr-main-accent-100',
    postponed: 'text-smtr-main-green-100',
};

export const bucketDropTargetConfigByKey: Record<
    TBucketKey,
    { titleKey: string; className: string }
> = {
    lost: {
        titleKey: 'crm.deals.board.bucket.dropTarget.lost',
        className: 'bg-smtr-main-bgGray-100',
    },
    postponed: {
        titleKey: 'crm.deals.board.bucket.dropTarget.postponed',
        className: 'bg-smtr-main-green-10',
    },
    'in_work_or_finished': {
        titleKey: 'crm.deals.board.bucket.dropTarget.inWorkOrFinished',
        className: 'bg-smtr-main-accent-50',
    },
};
